import { Redirect, Route } from 'react-router-dom';

import type React from 'react';

type PublicRouteProps = {
	isAuthenticated: unknown;
	component: React.ComponentType<any>;
	[key: string]: any;
};

export const PublicRoute = ({
	isAuthenticated,
	component: Component,
	...rest
}: PublicRouteProps) => {
	return (
		<Route
			{...rest}
			component={(props) =>
				isAuthenticated ? <Redirect to="/" /> : <Component {...props} />
			}
		/>
	);
};
